// extracted by mini-css-extract-plugin
module.exports = {"container":"CardPanel_container__xP8qy","navigationButtons":"CardPanel_navigationButtons__A4cIX","navigationTitle":"CardPanel_navigationTitle__iQbGx"};